module.exports = __webpack_public_path__ + "img/maoyi.21c7b178.png";